import { createSelector } from 'reselect';
import { createAsyncMetaSelectors } from '@mews/framework';
import { getContainer } from '@mews-commander/legacy-app-instance';
import { getCreditLimits } from '@mews-commander/legacy-entities/src/ducks/creditLimits';
import { createEntitySelectorByAccountId } from '@mews-commander/legacy-entities/src/ducks/utils';
import { getCompanyCreditRatingBasic } from '@mews-commander/legacy-entities/src/ducks/companies';
import { HIDE_SYMBOL_OPTION } from './constants';
import { moduleSelector } from './module';

const getModuleMeta = createSelector(moduleSelector, (state) => state.meta);

export const [isUpdating, hasUpdateFailed] = createAsyncMetaSelectors(getModuleMeta);

const getCreditLimitsByAccountId = createEntitySelectorByAccountId(getCreditLimits);

export const getCreditLimit = createSelector(getCreditLimitsByAccountId, (creditLimits) => creditLimits[0]);

export const getCreditLimitInitialValues = createSelector(
    getCreditLimit,
    getCompanyCreditRatingBasic,
    getContainer,
    (creditLimit, creditRatingBasic, container) => {
        if (!creditLimit || !creditLimit.amount) {
            return { value: null, currencyCode: null, creditRatingBasic: creditRatingBasic || null };
        }

        const { appLocalizationComponent } = container();
        const localizedCurrencyValue = appLocalizationComponent.localizeCurrencyValue(
            { value: creditLimit.amount.value, currency: creditLimit.amount.currencyCode },
            HIDE_SYMBOL_OPTION
        );

        return {
            value: localizedCurrencyValue,
            currencyCode: creditLimit.amount.currencyCode,
            creditRatingBasic: creditRatingBasic || null,
        };
    }
);
